import React, { Component } from 'react'
import '../css/locationSearchInput.css';

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'

class locationSearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = { address: '' };
  }
  getStepNewUbication =(latLng,name)=>{
    this.props.get_go_to('StepNewUbication',latLng.lat,latLng.lng,name)
  }
  handleChange = address => {
    this.setState({ address });
    //console.log("chan")
  };
  getUbicacion = (results)=>{
    getLatLng(results)
    .then((latLng) =>  this.getStepNewUbication(latLng ,results.formatted_address))
    .catch(error => console.error('Error', error))
  }
  handleSelect = address => {
    geocodeByAddress(address)
      .then((results) => this.getUbicacion(results[0]) )
      .catch(error => console.error('Error', error));
  };

  render() {
    const searchOptions = {
      componentRestrictions: {country: "ec"}
     }

    return (
      <React.Fragment><br/><br/><br/><br/><br/>
      <div className="modal-dialog-find-ubication">
        <div className="modal-content-find-ubication">
          <div className="grid-container-menu-find-ubication">
            <div className="div_menu_1-find-ubication">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }
              onClick={ () => this.props.get_go_to_step('ubicacion')} />
            </div>
            <div className="lbl_menu_2-find-ubication">
              <span className="span-global-link">Ingrese su Ubicación</span>
            </div>
          </div>
          <PlacesAutocomplete
            value={this.state.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
            searchOptions={searchOptions}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
              <div>
                <input
                  {...getInputProps({
                    placeholder: 'Buscar Dirección ...',
                    className: 'location-search-input',
                  })}
                />
                <div className="autocomplete-dropdown-container">
                  {loading && <div>Loading...</div>}
                  {suggestions.map(suggestion => {
                    const className = suggestion.active
                      ? 'suggestion-item--active'
                      : 'suggestion-item';
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                      : { backgroundColor: '#ffffff', cursor: 'pointer' };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
        </div>
      </div>
    </React.Fragment>
    );
  }
}
export default locationSearchInput
